<script setup>
/**
 * @deprecated Named close affordance — now a thin preset over the canonical
 * <BaseButton variant="ghost" square icon="x"> (design §3c). Prefer BaseButton
 * directly in new code. The look is the flat ghost-square X (transparent bg,
 * currentColor lucide icon), replacing the old round/filled ✕.
 *
 * Attribute fall-through preserves behaviour: @click, title, aria-label and a
 * positioning `class` (e.g. modal headers' `absolute top-7 right-7`) reach the
 * underlying button via BaseButton's $attrs/class passthrough.
 */
import BaseButton from "@/Components/UI/buttons/BaseButton.vue";
import { warnDeprecatedButton } from "@/Components/UI/buttons/deprecatedPreset.js";

warnDeprecatedButton("CloseButton", '<BaseButton variant="ghost" square icon="x">');
</script>

<template>
    <!-- Muted until hovered: ghost's default is accent-blue, but a close × is a
         secondary affordance and must not compete with the content it sits next to.
         Modal/sidebar headers already hand-rolled these exact two classes. -->
    <BaseButton
        variant="ghost"
        square
        icon="x"
        class="text-dark-light hover:text-accent-blue" />
</template>
